// extracted by mini-css-extract-plugin
module.exports = {"main":"FunnelCart_main__JzbiO","buy_from_btn_wrapper":"FunnelCart_buy_from_btn_wrapper__35oC_","products_title":"FunnelCart_products_title__xr1hD"};